<template>
  <div class="hero is-light-grey is-fullheight">
    <!-- Hero image -->
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="columns is-vcentered mt-80 mb-80">
          <div class="column is-6 is-offset-3">
            <!-- Login form -->
            <div id="login-card" class="animated preFadeInLeft fadeInLeft">
              <div class="flex-card clean-login-card">
                <router-link to="/" class="logo">
                  <img class src="~/../assets/images/logos/brand-logo.png" alt>
                </router-link>

                <b-message title="تنبيه" :type="messagetype" class="pb-10 pt-20">{{ message }}</b-message>

                <form @submit.prevent="validateBeforeSubmit()">
                  <div class="field">
                    <div class="control">
                      <input
                        v-model="customerInfo.Code"
                        name="code"
                        class="input has-text-centered has-text-black is-large"
                        type="text"
                        placeholder=" كود التفعيل"
                        autofocus
                        v-validate="'required|numeric'"
                        :class="{'input': true, 'is-danger': errors.has('code') }"
                      >
                      <span
                        v-show="errors.has('code')"
                        class="help is-danger is-centered"
                      >{{ errors.first('code') }}</span>
                    </div>
                  </div>

                  <div class="mt-20">
                    <!-- <router-link to="/book" >   <a class="button  is-info is-large is-fullwidth raised "> تأكيد </a></router-link> -->
                    <button
                      class="button is-rounded is-info is-wati is-large is-fullwidth"
                      type="submit"
                      v-bind:class="{ 'is-loading' : isLoading}"
                    >تأكيد</button>
                  </div>
                </form>
              </div>

              <div class="hero-foot has-text-centered mt-20"></div>
            </div>
            <!-- /Login form -->
            <!-- Recover form -->
            <!-- /Recover form -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Hero image -->
  </div>
</template>


<script>
import arabic from "vee-validate/dist/locale/ar";

export default {
  name: "verify",
  data() {
    return {
      code: "",
      local: "ar",
      message: "سوف تسلم رسالة نصية تحمل كود التفعيل رجاء ادخال الكود بالاسفل",
      messagetype: "is-info",
      isLoading: false,
      customerInfo: {
        CustomerID: "",
        Code: ""
      }
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.verifiy();
          return;
        }
      });
    },
    verifiy() {
      this.isLoading = !this.isLoading;
      axios
        .post("customer/verify", this.customerInfo)
        .then(response => {
          if (response.data.status === "success") {
            this.isLoading = !this.isLoading;
             console.log(response.data);

            this.$router.push({ name: 'book', params: {customer_id: response.data.customer_id,branch_id: response.data.branch_id }})
          } else if (response.data.status === "fail") {
            this.message = response.data.message;
            this.isLoading = !this.isLoading;

            this.messagetype = "is-danger";
             console.log(response.data.message);
          }
        })
        .catch(error => {
             console.log(response.error);

          this.isLoading = !this.isLoading;
          this.$router.push("/");
        });
    }
  },
  mounted() {
    this.customerInfo.CustomerID = this.$route.params.id;
    // this.$parent.isLoading = true;
    axios
      .get("customer/checkticket/" + this.customerInfo.CustomerID)
      .then(response => {
        // console.log(response);
        if (response.data.status === "fail") {
          this.$router.push("/");
        }

        this.$parent.isLoading = false;

      })
      .catch(error => {
        // this.$router.push('/');
      });
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        code: "كود التفعيل"
      }
    });
  }
};
</script>
